Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Modal1071601439",
  {"backdrop":"Modal1071601439--backdrop","modal":"Modal1071601439--modal","mobile":"Modal1071601439--mobile","preview":"Modal1071601439--preview","modalHeader":"Modal1071601439--modalHeader","modalTitle":"Modal1071601439--modalTitle","modalText":"Modal1071601439--modalText","modalButtons":"Modal1071601439--modalButtons","button":"Modal1071601439--button","close":"Modal1071601439--close","loader":"Modal1071601439--loader","root":"Modal1071601439--root"},
  "",
  1,
  "Modal1071601439"
);

